import { z } from "zod";

const UserValidationSchema = z.object({
	name: z.string().min(1, "Name is required").max(255),
	email: z.string().email("Invalid email format"),
	password: z
		.string()
		.min(8, "Password must be at least 8 characters long")
		.max(25, "Password must be at most 25 characters long")
		.refine((val) => /[A-Za-z]/.test(val), {
			message: "Password must contain at least one letter",
		})
		.refine((val) => /\d/.test(val), {
			message: "Password must contain at least one number",
		}),
	role: z.string().min(1).max(255).optional(),
	active: z.boolean().optional(),
});

export default UserValidationSchema;
